<template lang="html">

  <div class="simulador-view margin-menu">

    <header class="encabezado-seccion row-start">
      <div class="container row-between">
        <h1>
          <span class="big">{{ $t('seo.cocheElectrico.titlePage') }}</span>
          <span class="small">{{ $t('seo.cocheElectrico.titleSubPage') }}</span>
        </h1>
      </div>
    </header>


    <div class="next-simulador column-center">
      <img src="/static/img/next-simulador.webp" alt="">
      <h4>Nuestro equipo está trabajando en el desarrollo de esta página.</h4>
      <h4>Si quieres acceder a un estudio personalizado para la instalación de cargador de vehículo eléctrico, contacta con nosotros.</h4>
      <div class="contenedor-botones row-center">
        <router-link class="btn -degree" :to="$t('enlaces.contacto')">Contacta</router-link>
      </div>
    </div>


    <!-- <template>
      <formulario-simulador v-if="!!!simuladorResult" @sendend="setsendend"></formulario-simulador>
      <loading-view @fin="setfinloading" v-if="!!simuladorResult && !!!finloading"></loading-view>
      <formulario-personales v-if="finloading && !showResults" :sim_id="simuladorResult.sim_id" @sended="setshowResults" @setHasEmail="setemail"></formulario-personales>
      <result-view v-if="showResults" :results="simuladorResult" :hasemail="hasemail"></result-view>
    </template>
     -->




  </div>


</template>

<script lang="js">

  import formulariosimulador from '@/components/view-parts/simulador/formulario-simulador';
  import loadingview from '@/components/view-parts/simulador/loading-view';
  import formulariopersonales from '@/components/view-parts/simulador/formulario-personales';
  import resultview from '@/components/view-parts/simulador/result-view';


  import router from '@/router';



  export default  {
    name: 'simulador',
    data(){
      return{
        simuladorResult :'',
        finloading : false,
        showResults : false,
        viewSimulador : false,
        hasemail : false
      }
    },
    methods :{
      setsendend(value){
        this.simuladorResult = value;
        $("html,body").animate( { scrollTop : 0 }, 800 );
        
      },
      setfinloading(){
        this.finloading = true;
      },
      setshowResults(){
        this.showResults = true
        router.replace({name : 'simulador', params:{ paso : 'resultado'}})
      },
      setemail(){
        this.hasemail = true;
      },
   
    },
    components : {
     'formulario-simulador' : formulariosimulador,
     'loading-view' : loadingview,
     'formulario-personales' : formulariopersonales,
     'result-view' : resultview,
   }
 }
</script>

<style scoped lang="scss">
  .simulador-view {
    display: inline-block;
    width: 100%;
    /*min-height: 100vh;*/
    padding-bottom: 100px;
  }
  

  .next-simulador{

    padding: 0 20px;

    img{
      max-width: 100%;
    }

    h4:first-of-type{
      margin-top: 50px;
      margin-bottom: 50px;
    }

    h4:last-of-type{
      margin-bottom: 50px;
    }

    .contenedor-botones .btn{
      margin: 0 10px;
    }

  }

  @media screen and (max-width: 520px){

    h4{
      font-size: 18px;
    }

    .next-simulador h4:first-of-type{
      margin-top: 25px;
      margin-bottom: 25px;
    }


    .next-simulador .contenedor-botones{
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
      
      .btn{
        margin-bottom: 20px;
      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/views/coche-electrico.vue